/* v8 ignore start */
import { all, fork, put, takeLatest } from 'redux-saga/effects';

import {
  namespace
} from './ComplexWizard.slice';

import {
  handleViewChange
} from 'containers/BaseWizard/BaseWizard.slice';

// reset active index to 0 if RESET_PATH actions is used
const resetPath = function* () {
  yield put(handleViewChange(0));
};

const resetPathSaga = function* () {
  yield takeLatest(`${namespace}\resetPath`, resetPath);
};

const sagas = function* () {
  yield all([
    fork(resetPathSaga)
  ]);
};

export default sagas;
